import axios from "axios";
import getApiDomain from "@/api/getApiDomain";

/**
 * Slides the session by asking the backend to re-issue a fresh JWT for the
 * currently stored token. The backend (LoginController::indexAction) returns a
 * new token when a valid token is presented in the X-HTTP-AUTHORIZATION header.
 *
 * Safety: this NEVER clears or overwrites the stored token with an invalid
 * value. If the refresh fails or returns no token, the existing (still valid,
 * month-long) token is left untouched.
 */
const refreshtoken = async (): Promise<string | null> => {
	const current = localStorage.getItem("auth_token");
	if (!current) {
		return null;
	}

	const response = await axios.post(
		getApiDomain() + "/login",
		{}, // empty body — auth travels in the header below
		{
			headers: {
				'X-HTTP-AUTHORIZATION': `Authenticate ${current}`,
				'Access-Control-Allow-Origin': '*',
			},
		}
	);

	const token = response.data?.token;
	if (response.data?.success && typeof token === "string" && token.length > 0) {
		localStorage.setItem("auth_token", token);
		return token;
	}

	// No valid token returned — keep the existing one in place.
	return null;
};

export default refreshtoken;
